export default __webpack_public_path__ + "static/media/image_12.04c8f91d.jpg";